import { ModulesMap } from '@/config/data/modulesMaps'
import InfrastructureTypesApi from '@/services/apiServiceModules/infrastructureTypesApi'
import DataTransferModule from '@/services/dataTransferModule'

const infrastructureTypesApi = new InfrastructureTypesApi()

export default class InfrastructureTypesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.INFRASTRUCTURE_TYPES, infrastructureTypesApi, {
			useCache: true,
		})
	}
}
